import * as Vonq from '../../share/Vonq.js';

export function getPagination() {
    return  {
        _pager: {},
        _args: {},
        init: function (pager, args) {
           this._args = args;
           if (pager && pager.next) {
             const pt = pager.next.split("?");
             if (pt.length === 2) {
                const urlParms = new URLSearchParams(pt[1]);
                for (const [key, value] of urlParms.entries()) {
                   this._args[key] = value || "";
                }
             }
           }
           this._pager = pager;
        },
        next: function (offset, limit) {
            if (offset) {
                this._args["offset"] = offset;
            }
            if (limit) {
                this._args["limit"] = limit;
            }
            this._args.pagination = this;
            return Vonq.api(this._args);
        }
    }
}